import { useEffect } from 'react';

export const useHttpsAutoRedirector = ({ conditionFn }) => {
  useEffect(() => {
    const doRedirect = conditionFn && typeof conditionFn === 'function' ? conditionFn() : true;

    if (doRedirect && window.location.protocol === 'http:') {
      window.location.protocol = 'https:';
    }
  }, [conditionFn]);
};
